var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutubeMobile = function SvgIconYoutubeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M18.518 5.76a2.2 2.2 0 0 0-1.554-1.557c-1.37-.367-6.864-.367-6.864-.367s-5.491 0-6.864.367a2.2 2.2 0 0 0-1.553 1.558C1.316 7.134 1.316 10 1.316 10s0 2.866.367 4.24a2.2 2.2 0 0 0 1.553 1.557c1.373.367 6.864.367 6.864.367s5.495 0 6.864-.367a2.2 2.2 0 0 0 1.554-1.558c.366-1.373.366-4.239.366-4.239s0-2.866-.366-4.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.345 12.642 12.91 10 8.345 7.358z"
  })));
};
export default SvgIconYoutubeMobile;